import React, { useEffect } from "react";
import PropTypes from "prop-types";
import "./ResponseModal.css";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import ErrorIcon from "@mui/icons-material/Error";
import { useDispatch } from "react-redux";
import { closeModal } from "../../../../redux/modal/modalActions";

function ResponseModal({ text, isError, autoDismissAfterMs }) {
  const dispatch = useDispatch();

  useEffect(() => {
    if (isError || !autoDismissAfterMs || autoDismissAfterMs <= 0) return undefined;
    const handle = window.setTimeout(() => {
      dispatch(closeModal());
    }, autoDismissAfterMs);
    return () => window.clearTimeout(handle);
  }, [dispatch, isError, autoDismissAfterMs]);

  return (
    <div
      className={`response-modal-container ${isError ? "response-modal--error" : "response-modal--success"}`}
      role="alert"
    >
      {isError ? (
        <ErrorIcon className="response-modal-icon" fontSize="large" color="error" />
      ) : (
        <DoneAllIcon className="response-modal-icon" fontSize="medium" color="success" />
      )}
      <div className="response-modal-message">{text}</div>
    </div>
  );
}

ResponseModal.propTypes = {
  text: PropTypes.string,
  isError: PropTypes.bool,
  autoDismissAfterMs: PropTypes.number,
};

ResponseModal.defaultProps = {
  text: "",
  isError: false,
  autoDismissAfterMs: 0,
};

export default ResponseModal;
